import { toast } from 'react-toastify';

// Shares a receipt text via the native Web Share API when it's available
// (most mobile browsers and modern desktop Chrome/Safari), falling back
// to the clipboard on desktop browsers that don't support it. The user
// gets a toast on both paths so they know the action succeeded.
//
// Silently ignores AbortError so an intentional cancel in the native
// share sheet doesn't surface as an error.
export async function shareReceiptText(text, title = 'Milipot receipt') {
    if (!text) return;

    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
        try {
            await navigator.share({ title, text });
            return;
        } catch (error) {
            if (error?.name === 'AbortError') return;
            // Any other rejection (permission denied, unsupported target, transient
            // share-sheet failure) is worth surfacing in the console so a persistent
            // failure does not look like the clipboard path was the intended flow.
            console.warn('Web Share API failed, falling back to clipboard:', error);
        }
    }

    if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
        try {
            await navigator.clipboard.writeText(text);
            toast.success('Receipt copied to clipboard.');
            return;
        } catch (error) {
            console.warn('Clipboard write failed:', error);
            toast.error('Could not copy the receipt. Please copy it from the card manually.');
            return;
        }
    }

    toast.info('Sharing is not supported on this browser. Please copy the receipt from the card manually.');
}
